import thinker from "@/assets/neurotypes/thinker.png";
import orator from "@/assets/neurotypes/orator.png";
import strategist from "@/assets/neurotypes/strategist.png";
import empath from "@/assets/neurotypes/empath.png";
import artist from "@/assets/neurotypes/artist.png";
import driver from "@/assets/neurotypes/driver.png";
import systematic from "@/assets/neurotypes/systematic.png";
import coordinator from "@/assets/neurotypes/coordinator.png";
import optimizer from "@/assets/neurotypes/optimizer.png";

export const NEUROTYPE_AVATARS = {
  S1: thinker,
  S2: orator,
  S3: strategist,
  E1: empath,
  E2: artist,
  E3: driver,
  T1: systematic,
  T2: coordinator,
  T3: optimizer,
};
